// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 339 ? "60f63151" : chunkId) + "." + {"187":"9adc6a09d9f70c98","339":"a99e34f644aba1a4"}[chunkId] + ".js";
};